import {Component, OnInit} from '@angular/core';
import {AppointmentService} from '@services/appointment.service';
import {Appointment} from '@models/appointment.model';
import * as moment from 'moment';
import {Tab} from '@models/tab.model';
import {attentionsTabHomeIds} from '@shared/constants/attentions.constants';
import {Intervention} from '@models/intervention.model';
import {InterventionService} from '@services/intervention.service';
import {PermissionService} from '@services/permission.service';

@Component({
  selector: 'si-attentions-upcoming',
  templateUrl: './attentions-upcoming.component.html',
  styleUrls: ['./attentions-upcoming.component.scss']
})
export class AttentionsUpcomingComponent implements OnInit {
  appointments: Appointment[];
  appointmentSort: string;
  appointmentStartDate: number;
  appointmentPending = true;
  interventionSort: string;
  interventionStartDate: number;
  hasItemsAppointment: boolean;
  hasItemsIntervention: boolean;
  interventions: Intervention[];
  attentionsTabHomeIds = attentionsTabHomeIds;
  selectedTabId: number;
  loadedItemsAppointment: boolean;
  loadedItemsIntervention: boolean;
  tabs: Tab[] = [
    {
      id: this.attentionsTabHomeIds.APPOINTMENT_TAB,
      name: 'SI_APPOINTMENTS',
    },
    {
      id: this.attentionsTabHomeIds.INTERVENTION_TAB,
      name: 'SI_INTERVENTIONS',
    }
  ];

  constructor(
    private appointmentService: AppointmentService,
    private interventionService: InterventionService,
    private permissionService: PermissionService
  ) {
  }

  ngOnInit(): void {
    this.initAppointmentFilters();
    this.initInterventionFilters();
    this.initTab();
  }

  initAppointmentFilters(): void {
    this.appointmentStartDate = moment().startOf('day').valueOf();
    this.appointmentSort = 'startDate';
  }

  initInterventionFilters(): void {
    this.interventionStartDate = moment().startOf('day').valueOf();
    this.interventionSort = 'interventionDate';
  }

  initTab(): void {
    if (!this.permissionService.hasPermission('appointment_management:search')) {
      this.tabs = this.tabs.filter(tab => tab.id !== this.attentionsTabHomeIds.APPOINTMENT_TAB);
    } else if (!this.permissionService.hasPermission('intervention:search')) {
      this.tabs = this.tabs.filter(tab => tab.id !== this.attentionsTabHomeIds.INTERVENTION_TAB);
    }

    this.onSelectTab(this.tabs[0].id);
  }

  setActiveState(): void {
    this.tabs.forEach(tab => tab.active = tab.id === this.selectedTabId);
  }

  onSelectTab(tabId: number): void {
    this.selectedTabId = tabId;
    this.setActiveState();

    if (tabId === this.attentionsTabHomeIds.APPOINTMENT_TAB && !this.loadedItemsAppointment) {
      this.getAppointments();
    } else if (tabId === this.attentionsTabHomeIds.INTERVENTION_TAB && !this.loadedItemsIntervention) {
      this.getInterventions();
    }
  }

  async getAppointments(page = 0, size = 3): Promise<void> {
    try {
      this.appointments = await this.appointmentService.getAppointments(
        page,
        size,
        this.appointmentSort,
        this.appointmentPending,
        this.appointmentStartDate
      );
      this.hasItemsAppointment = !!this.appointments.length;
    } finally {
      this.loadedItemsAppointment = true;
    }
  }

  async getInterventions(page = 0, size = 3): Promise<void> {
    try {
      this.interventions = await this.interventionService.getInterventions(
        page,
        size,
        this.interventionSort,
        this.interventionStartDate
      );
      this.hasItemsIntervention = !!this.interventions.length;
    } finally {
      this.loadedItemsIntervention = true;
    }
  }

  onConfirmAttendance(): void {
    this.getAppointments();
  }
}
